<template>
  <section class="w-full h-full pt-4 flex flex-col overflow-hidden box-border">
    <div class="flex-1 mx-4 mb-4 bg-white overflow-auto rounded shadow-theme">
      <card-tabs v-model="activeTab" :tabs="tabs">
        <sms-batch :step="step" slot="batchSM" :key="batchSMKey" ref="batchSMRef" />
        <sms-batch-record slot="batchRecord" ref="batchRecordRef" :recordId="recordId" />
        <sms-already slot="alreadySM" ref="alreadySMRef" />
      </card-tabs>
    </div>
    <footer v-if="showFooter" class="w-full h-14 bg-white flex items-center justify-end px-4 box-border shadow-theme">
      <el-button
        size="small"
        class="normal-button theme-black-250"
        :loading="source.prevLoading"
        v-if="step > 0"
        @click="prevStep"
        >上一步</el-button
      >
      <el-button type="primary" size="small" class="normal-button" :loading="source.nextLoading" v-if="step < 3" @click="nextStep"
        >下一步</el-button
      >
    </footer>
    <ExamineDialog
        v-if="examineVisible"
        :visible.sync="examineVisible"
        :examine-data="examineData"
        @callBackSuccess="handleCallBack"
    />
  </section>
</template>

<script>
import CardTabs from '@/components/base/CardTabs'
import { removeSmsSamples, getQuerySmsAuditH } from '@/api/wenjuan/sample_new'
import GlobalConfig from '@/global/config'
import SmsBatch from './components/SmsBatch'
import SmsBatchRecord from './components/SmsBatchRecord'
import SmsAlready from './components/SmsAlready'
import { smTabs } from './config/sms-sending'
import ExamineDialog from '@/views/survey/publish/sms-approve/ExamineDialog.vue'
import { mapGetters } from 'vuex'
import { getSmsAudit } from '@/api/pay/sms'

export default {
  name: 'SmsSending',
  components: {
    CardTabs,
    SmsBatchRecord,
    SmsAlready,
    SmsBatch,
    ExamineDialog
  },
  provide() {
    return {
      source: this.source,
      prevStep: this.prevStep,
      nextStep: this.nextStep,
      switchTab: this.switchTab,
      resetGSM: this.resetGSM
    }
  },
  data() {
    return {
      activeTab: 'batchSM',
      // 因为要从发布渠道页面跳转到群发记录 并携带批次编号的值
      // 群发记录接口会根据这个值 自动查询对应编号
      recordId: 0,
      batchSMKey: Date.now(),
      tabs: smTabs,
      step: -1,
      source: {
        activeTab: this.activeTab,
        prevLoading: false,
        nextLoading: false,
        selectTotal: 0,
        smsCheck: null,
        smsRecord: {},
        smsContent: '',
        smsMoney: '',
        money: '',
        comment: ''
      },
      examineVisible: false,
      examineData: null
    }
  },
  created() {
    const activeTab = this.$route.query.activeTab
    if (activeTab) {
      this.activeTab = activeTab
    }
    const recordId = this.$route.query.recordId
    if (recordId) {
      this.recordId = Number(recordId)
    }
    this.getQuerySmsAudit();
    this.eventListenerStep();
    this.getQySmsAudit()

  },
  computed: {
    ...mapGetters(['userInfo']),
    showFooter() {
      return this.activeTab === 'batchSM' && this.source.selectTotal > 0 && this.step < 3
    }
  },
  watch: {
    activeTab(activeTab) {
      this.source.activeTab = activeTab
    }
  },
  beforeDestroy() {
    if (this.source.selectTotal > 0) {
      this.removeAllList()
    }
  },
  methods: {
    resetSource(){
      console.log("reset source")
      this.source.prevLoading = false
      this.source.nextLoading = false
      this.source.selectTotal = 0
      this.source.smsCheck = null
      this.source.smsRecord = {}
      this.source.smsContent = ''
      this.source.smsMoney = ''
      this.source.money = ''
      this.source.comment = ''
    },
    getQySmsAudit(){
      if (!this.userInfo.isQY) return
      getSmsAudit(GlobalConfig.getSurveyId()).then(res=>{
        if (res.data?.data) {
          this.step = 6
          this.source.selectTotal = res.data.data.smsPerson
          this.source.smsCheck = res.data.data.smsTemplateType
        } else{
          this.step = 0
        }
      })
    },
    // 改变当前步骤切换对应组件状态
    eventListenerStep(){
      this.$surveyBus.$on('updateStep',({step,isExamine,data})=> {
        if (step <= 0) {
          this.examineData = {}
          this.resetSource()
        }
        this.step = step
        if(isExamine){
          this.examineVisible = true;
          this.examineData = data
        }
      })
    },
    getQuerySmsAudit() {
      if (this.userInfo.isQY) return
      const surveyId = GlobalConfig.getSurveyId()
      getQuerySmsAuditH({ surveyId }).then(res => {

        // 模拟初始化渲染短信审批页面后期删除
        // this.step = 6
        // return

        const data = res.data.data
        if (!data || data.auditStatus === 3) {
          this.step = 0
          return
        }

        const { auditStatus, freezesNo, recordId, money, comment, versionId } = data
        // 0-审核中 1-成功 2-失败 3-成功并且可再次群发
        if (auditStatus === 0) {
          this.step = 3
          this.source.smsRecord = {
            sendResult: true
          }
        } else if (auditStatus === 1) {
          this.step = 4
        } else if (auditStatus === 2) {
          this.step = 5
          this.source.auditStatus = auditStatus
          this.source.freezesNo = freezesNo
          this.source.recordId = recordId
          this.source.money = money
          this.source.comment = comment
          this.source.versionId = versionId
        }
      })
    },
    prevStep() {
      if (this.step > 0) {
        this.step--
      }
    },
    /**
     *
     * @param {number} step -自定义显示某个组件
     */
    nextStep(step) {

      const isQY = this.userInfo.isQY// 后期删除此标识
      // 判断当前步骤为1 并且为清研公司
      if (this.step === 1 && isQY) {
        console.log('进入短信审核')
        this.examineData = {
          id: null,
          ...(this.examineData || {}),
          smsContent: this.source.smsContent,
          smsTemplateType: this.source.smsCheck,
          smsPerson: this.source.selectTotal
        }
        this.examineVisible = true
        // this.step = 6
        return
      }

      // 防止是事件对象
      if (typeof step === 'number') {
        this.step = step
        this.source.smsRecord.sendResult = true
        return
      }
      if (this.step < 3) {
        this.step++
      }

      console.log('step',step)
    },
    switchTab(name, fn) {
      if (name) {
        this.activeTab = name
        const instance = this.$refs?.[`${name}Ref`]
        if (instance && typeof fn === 'function') {
          // 调用回调函数
          fn(instance)
        }
      }
    },
    resetGSM() {
      this.step = 0
      this.source.prevLoading = false
      this.source.nextLoading = false
      this.source.selectTotal = 0
      this.source.smsCheck = null
      this.source.smsRecord = {}
      this.source.smsContent = ''
      this.source.smsMoney = ''
      this.removeAllList()
    },
    removeAllList() {
      removeSmsSamples({
        sampleIds: [],
        groupIds: [],
        surveyId: GlobalConfig.getSurveyId()
      })
        .then(() => {
          this.batchSMKey = Date.now()
        })
        .catch(() => {
          this.$message.error('清除收信人失败')
        })
    },
    //  审批相关方案
    handleCallBack(){
      this.step = 6
    }
  }
}
</script>

<style scoped></style>
